exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#check[data-v-29a98108]{background:#f5f5f5;min-height:100%}.card[data-v-29a98108]{padding:0 5px;background:#fff;margin-bottom:10px}.card h3[data-v-29a98108]{line-height:50px;border-bottom:1px solid #b5b5b5;color:#858585;font-size:19px}.card p[data-v-29a98108]{color:#323232;font-size:17px;line-height:30px;min-height:60px;padding:10px 0}.btns[data-v-29a98108]{display:flex;padding:10px}.btns a[data-v-29a98108]{display:block;margin:0 10px;background:#c8c8c8;color:#fff;text-align:center;height:45px;line-height:45px;border-radius:3px;flex:1;font-size:18px}.btns a[data-v-29a98108]:nth-child(2n){background:#4a7ae6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-29a98108","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/exchange/check.vue
// module id = 503
// module chunks = 0